import { Suspense } from "react";
import { observer } from "mobx-react";
import { loginSettingsData } from "Pages/Login/Stores/LoginSettingsStore";
import { LoadAsync } from "Components/General/Loadable";
import { userInfoStore } from "Stores";

const Pro4allButtonLazy = LoadAsync(() => import(/* webpackChunkName: "p4allLauncher" */ "./Pro4AllButton"));

export const Pro4allLauncher = observer(() => {
  if (!loginSettingsData.data.pro4AllLauncherEnabled) {
    return null;
  }
  return (
    <Suspense fallback={null}>
      <Pro4allButtonLazy locale={userInfoStore.language} />
    </Suspense>
  );
});
